module.exports = new __parcel__URL__("overview.a1b80899.svg").toString();